import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const PostCampaign = {
  Helmet: lazy(() => import('./components/PostCampaignHelmet')),
  CampaignsList: lazyNamed(() => import('./scenes/CampaignsList'), 'CampaignsList'),
  Overview: lazy(() => import('./scenes/Overview')),
  Edit: lazy(() => import('./scenes/BookingTool/containers/PostCampaignEdit')),
  Information: lazy(() => import('./scenes/BookingTool/containers/PostCampaignInformation')),
  TargetGroupSettings: lazy(() => import('./scenes/BookingTool/containers/PostCampaignTargetGroupSettings')),
  Calculation: lazyNamed(() => import('./scenes/BookingTool/containers/PostCampaignCalculation'), 'PostCampaignCalculationRenderer'),
  EditPositions: lazy(() => import('./scenes/BookingTool/containers/PostCampaignPositionsEdit')),
  DocumentPreview: lazy(() => import('./scenes/BookingTool/containers/PostCampaignPreview')),
  BookingToolProviders: lazy(() => import('src/modules/PostCampaign/providers/PostBookingToolProviders')),
  ListAndOverviewProviders: lazy(() => import('src/modules/PostCampaign/providers/ListAndOverviewProviders')),
  Providers: lazyNamed(() => import('src/modules/PostCampaign/providers/PostCampaignProviders'), 'PostCampaignProviders'),
  History: lazyNamed(() => import('./scenes/History'), 'History'),
};

export default PostCampaign;
